import React from 'react';
import { FilePenLine, FolderOpen } from 'lucide-react';
import type { DokumenteAreaTab } from '../portalNavigation';

export interface DokumenteAreaTabsProps {
  activeTab: DokumenteAreaTab;
  onTabChange: (tab: DokumenteAreaTab) => void;
  documentTitle?: string | null;
}

const TABS: { id: DokumenteAreaTab; label: string; shortLabel: string; Icon: typeof FilePenLine }[] = [
  { id: 'editor', label: 'Editor', shortLabel: 'Editor', Icon: FilePenLine },
  { id: 'hub', label: 'Meine Dokumente', shortLabel: 'Liste', Icon: FolderOpen },
];

export const DokumenteAreaTabs: React.FC<DokumenteAreaTabsProps> = ({
  activeTab,
  onTabChange,
  documentTitle,
}) => (
  <div
    className="portal-shell-doc-bar flex gap-1 p-1 rounded-lg bg-white/[0.04] border border-white/[0.06] w-full sm:w-fit shrink-0"
    role="tablist"
    aria-label="Dokumente-Bereich"
  >
    {TABS.map((tab) => {
      const selected = activeTab === tab.id;
      const editorHint =
        tab.id === 'editor' && documentTitle?.trim()
          ? documentTitle.trim()
          : tab.label;
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={selected}
          onClick={() => onTabChange(tab.id)}
          className={`inline-flex items-center gap-1.5 px-3 sm:px-4 py-1.5 rounded-md text-sm font-medium transition-colors min-w-0 ${
            selected ? 'bg-white/[0.08] text-white' : 'text-slate-500 hover:text-slate-300'
          }`}
        >
          <tab.Icon className="w-3.5 h-3.5 flex-shrink-0" aria-hidden />
          <span className="truncate sm:hidden">{tab.shortLabel}</span>
          <span className="truncate hidden sm:inline max-w-[min(100%,280px)]">{editorHint}</span>
        </button>
      );
    })}
  </div>
);
